<script lang="ts" setup>
defineOptions({
  name: 'PalkLogoColor'
});
import logo from '@/assets/logo-palk-color.svg';

const props = defineProps<{
  /**
   * Size(width) of the logo in pixels, e.g., '55px'
   */
  size?: number;
}>();

</script>

<template>
  <img :src="logo"
       :width="props.size"
       alt="Palk Logo Color"/>
</template>

<style scoped>
</style>